export default {
  classAssignment: {
    id: "",
    classSectionId: null,
    sectionNo: null,
    topicLocal: null,
    topicEng: null,
    descriptionLocal: null,
    descriptionEng: null,
    score: null,
    dueDate: null,
    uploadPath: null,
    uploadPathUri: null,
    uploadFileName: null,
  },
  classAssignments: [],
  processing: false,
  error: null,
  success: null,
}



